import { Icon } from "@blueprintjs/core"
import React from "react"
import CustomTag from "components/Atoms/CustomTag"
import { useCurrentDepot } from "store/auth.redux"
import { useFilter } from "store/search-filter/search-filter.reducer"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { DEPOTS } from "graphql/selector.queries.gql"

const ProductionDepotSelector = () => {
  const [depot, setDepot] = useCurrentDepot()
  const [depotFilter, setDepotFilter] = useFilter("depot")

  const handleClear = () => {
    setDepot(null)
    setDepotFilter({
      ...depotFilter,
      depot: null,
    })
  }

  return (
    <span
      style={{ backgroundImage: "/images/hero.png" }}
      className="em-dc-selector"
    >
      <Icon className="mx-2" icon="chevron-right" />
      <DynamicSelector
        query={DEPOTS}
        className="mb-0"
        onChange={(_, value) => {
          setDepot(value)
          setDepotFilter({
            ...depotFilter,
            depot: value,
          })
        }}
      >
        {() => {
          return (
            <CustomTag
              data-testid="distribution-center-dropdown"
              large
              className="d-center em-dc-selector-tag"
              interactive
              minimal
              intent="primary"
              onRemove={depot ? handleClear : undefined}
              rightIcon={
                <Icon className="ml-1" icon="chevron-down" iconSize={10} />
              }
            >
              {depot?.name ? depot?.name : "All Depot"}
            </CustomTag>
          )
        }}
      </DynamicSelector>
    </span>
  )
}

export default ProductionDepotSelector
